module.exports = __webpack_public_path__ + "img/sup_login_4.07899cdd.png";